import { useMutation, useQueryClient } from '@tanstack/react-query'

import { fetcher } from '@/src/general/utilities/fetcher'
import { storage } from '@/src/general/utilities/storage'
import { STORAGE_KEYS } from '@/src/general/utilities/storage/MMKVStorage'
import { Cookie } from '@/src/general/utils/cookies/Cookie'

import { getMeQueryOptions } from '../../auth/services/useMeQuery'
import { authTokenStorage } from '../../auth/utils/authTokenStorage'
import { settingsApi } from '../api/settingsApi'
import type { TEditAccountSettingsPayload } from '../api/types/editAccountSettings.types'

export const useSettingsMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: TEditAccountSettingsPayload) => settingsApi.editAccountSettings(payload),
    onSuccess: ({ token, ...me }) => {
      queryClient.setQueryData(getMeQueryOptions().queryKey, (oldData) => oldData && { ...oldData, ...me })
      if (token) {
        fetcher.setXAuthToken(token)
        authTokenStorage.setToken(token)
        Cookie.set('jwtToken', token, 'oneYear')
      }
      const { token: _token, ...storedMe } = JSON.parse(storage.getItem(STORAGE_KEYS.ME) || '{}') as Record<
        string,
        unknown
      >
      const newStoredMe = { ...storedMe, ...me }
      storage.setItem(STORAGE_KEYS.ME, JSON.stringify(newStoredMe))
    },
  })
}
